export const redactions = ['req.headers.authorization', 'req.headers.cookie'];

const options = {
  redact: redactions,
};

export default options;
